import { call, put, take } from 'redux-saga/effects';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import * as types from 'src/state/ducks/orderItem/types';
import * as actions from 'src/state/ducks/orderItem/actions';
import * as api from 'src/state/ducks/orderItem/api';
import { Status } from 'src/constants/Interface';
import ValidationManager from 'src/firebase/db/ValidationManager';
import { OrderEntity, orderEntityKeys } from 'src/firebase/db/Orders';

dayjs.extend(isSameOrAfter);

function* validateOrderItem() {
  while (true) {
    const { payload } = yield take(types.VALIDATE_ORDER_ITEM);

    // 入力された値を検証する
    const form = payload as OrderEntity;
    const validator = new ValidationManager();

    // 入力必須
    const IS_REQUIRED = ['scheduled_time', 'last_pickup_time', 'can_order_time'];

    orderEntityKeys.forEach((key) => {
      if (IS_REQUIRED.includes(key)) {
        validator.isRequired(key, form[key]);
      }

      switch (key) {
      }
    });

    if (validator.isPass()) {
      // yield put(push(`/order/create/confirm}`));
      yield put(actions.successValidateOrderItem(payload));
    } else {
      const errors = validator.throwValidateError(validator.getErrors());
      yield put(actions.failValidateOrderItem(errors));
    }
  }
}

function* getOrderItems() {
  while (true) {
    const { payload } = yield take(types.GET_ORDER_ITEMS);
    console.log(payload);
    try {
      const res = yield call(api.getOrderItems, payload.shopId);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successGetOrderItems(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failGetOrderItems(res));
      }
    } catch (err) {
      yield put(
        actions.failGetOrderItems({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

function* createOrderItem() {
  while (true) {
    const { payload } = yield take(types.CREATE_ORDER_ITEM);
    try {
      const res = yield call(api.createOrderItem, payload);
      if (res.status === Status.SUCCESS) {
        yield put(actions.successCreateOrderItem(res));
      } else if (res.status === Status.INVALID) {
        yield put(actions.failCreateOrderItem(res));
      }
    } catch (err) {
      console.log({ err });
      yield put(
        actions.failCreateOrderItem({
          status: Status.FAILURE,
          error: {
            code: 500,
            message: err.message,
          },
        }),
      );
    }
  }
}

const orderItem = [getOrderItems(), validateOrderItem(), createOrderItem()];

export default orderItem;
